import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from '../../../app.service';
import { MatDialog } from '@angular/material/dialog';import { NotificationsService } from 'angular2-notifications';
import { Family, GenericIdName, UpdateCustomerVM, DigitalFormDataVM, DigitalFormQuestionsCategoriesVM, DigitalFormQuestionsVM, DigitalFormVM, DigitalFormQuestionTypesVM, AddQuestionVM, FormHeaderVM, ImplementLoadVM, GenericIdName_, FamilyVM } from '../models/digitalForm.model';
import {  DigitalFormServiceIdentity } from '../services/digital-form.service';
import { CustomerOverview } from '../models/customer.model';
import { CustomerServiceIdentity } from '../services/customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AddFormcategoryComponent } from './components/add-formcategory/add-formcategory.component';
import { DOCUMENT } from '@angular/common';
import { ConfirmDialogComponentIdentity } from './components/confirm-dialog/confirm-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { JobsiteSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';


@Component({
  selector: 'app-create-digital-form',
  templateUrl: './create-digital-form.component.html',
  styleUrls: ['./create-digital-form.component.scss']
})
export class CreateDigitalFormComponent implements OnInit {

  applytoMachines:boolean =true;
  emailOnclomplete:boolean;
  startbyInspector:boolean = false;
  startbySupervisor:boolean = false;
  FECRForm:boolean;
  formName:string;
  selectedFamilies:Family;
  familyList:Family[];
  familyId:number[];
  customerId:number[];
  JobsiteId:number[];
  modelId:number[];
  modelList: GenericIdName[] = [];
  FormCatList: GenericIdName[] = [];
  customerList: CustomerOverview[];
  jobsiteList:GenericIdName_[];
  FormcatId:number;
  familyFilteredList:GenericIdName_[];
  formId:number=0;
  showModelList:boolean=false;
  isFormCategorySelect:boolean=false;
  DigtalFormOverview:DigitalFormDataVM;
  formQSections : DigitalFormQuestionsCategoriesVM[]=[];
  formQCategories : DigitalFormQuestionsCategoriesVM[]=[];
  formQuestions : DigitalFormQuestionsVM[]=[];
  form :DigitalFormVM;
  questionTypes:DigitalFormQuestionTypesVM[]=[];
  //form Header
  header_Date:boolean;
  header_Rivision:boolean;
  header_Username:boolean;
  header_CusJob:boolean;
  header_Unit:boolean;
  header_Smu:boolean;
  header_WorkOrder:boolean;
  //FECR
  showFECRTypes:boolean=false;
  fecrInspectionTypeId:number;
  FECRInspectionTypes:GenericIdName[]=[];
  filteredFamilyList:FamilyVM[];
  filteredModelList: GenericIdName_[]=[];
  ImplementTemplateList:GenericIdName[];
  headerFormList:FormHeaderVM[];
  ImpTemplateId:number[];
  constructor(
    private _appService: AppService,
    private _formService:DigitalFormServiceIdentity,
    private _customerService:CustomerServiceIdentity,
    public dialog: MatDialog, private _dialog: MatDialog,
    private _route: ActivatedRoute, private _router: Router,
    private _sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private _document: Document,
    private _favouriteDialogService:FavouriteDialogService,
    private _notification: NotificationsService) { }

  ngOnInit() {
    this._appService.setPageTitle('Create Digital Form');
    this.loadFormCatList();
    this.loadFamilyList();
    this.loadFECRInspectionTypes();
   // this.formId = this._route.snapshot.params.id;
    this._customerService.getAllCustomers().subscribe(response => {
      this.customerList = response;
  });
  }

  loadFamilyList() {
    this._formService.getFamilyListData().subscribe(result => {
      this.familyList = result
    });
  }

  loadFormCatList() {
    this._formService.getFormCategoryList().subscribe(result => {
      this.FormCatList = result
    });
  }

  loadFECRInspectionTypes(){
    this._formService.getFECRInspectionTypes().subscribe(result=>{
      this.FECRInspectionTypes = result;
    });
  }

  SelectFECRInspectionType(){
    this._formService.UpdateFECRFromType(this.formId, this.fecrInspectionTypeId).subscribe(res=>{
      if(res>0){
        this._notification.success('Saved','Update Component Rebuild Type')
      }else{
        this._notification.error('Failed','Failed to update Component Rebuild Type')
      }
    });
  }

  GetDigitalFormDetails(){
    this._formService.GetDigitalFormDetails(this.formId).subscribe(res=>{
      this.DigtalFormOverview = res;
      this.form = this.DigtalFormOverview.DigitalForms;
      this.formQCategories=this.DigtalFormOverview.ParentCategories;
      this.formQSections=this.DigtalFormOverview.CategorySections;
      this.formQuestions=this.DigtalFormOverview.Questions;
      this.questionTypes=this.DigtalFormOverview.QuestionTypes;
      this.FECRForm = this.form.FECRForm;
      console.log("DigtalFormOverview__", this.DigtalFormOverview,this.formQCategories, this.formQSections)
      this.GetFormHeader();
      console.log("data___11", this.showFECRTypes,this.FECRForm )
      if((this.showFECRTypes==true && !this.FECRForm) || (this.showFECRTypes==false && this.FECRForm)){
        this._formService.UpdateFECRForm(this.formId).subscribe(res=>{
          if(res>0){}
         // this._notification.success('Updated','Update the Form')
        else
          this._notification.error('Failed','Failed to update the Form')
        });
      }
    });
  }

  GetFormHeader(){
    this._formService.GetDigitalFormHeaderFields(this.formId).subscribe(res=>{
      console.log("headerinfo", res);
      this.headerFormList= res;
      this.formQuestions.map(q=>{
        let check =  this.headerFormList.find(y=>y.qid == q.QuestionId);
        if(check){
          q.isIncludeHeader=true;
        }else{
          q.isIncludeHeader=false;
        }
      });
      this.header_Username=false;
      this.header_CusJob=false;
      this.header_Date=false;
      this.header_Rivision=false;
      this.header_Unit=false;
      this.header_Smu=false;
      this.header_WorkOrder=false;
      this.headerFormList.map(x=>{
        if(x.standardField == 1)
          this.header_Username=true;
       
        if(x.standardField == 2)
          this.header_Rivision=true;
       
        if(x.standardField == 3)
          this.header_Date=true;
      
        if(x.standardField == 4)
          this.header_CusJob=true;

        if(x.standardField == 5)
          this.header_Unit=true;

        if(x.standardField == 6)
          this.header_Smu=true;

        if(x.standardField == 7)
          this.header_WorkOrder=true;
      });
    });
  }
  ChangeHeader(standardId:number,event:any){
   let check = this.headerFormList.find(x=>x.standardField==standardId);
   if(check){
      this._formService.UpdateFormHeader(standardId,0,this.formId).subscribe(res=>{
        if(res)
        this.GetFormHeader();
      })
   }else{
     if(this.headerFormList.length<8){
      this._formService.UpdateFormHeader(standardId,0,this.formId).subscribe(res=>{
        if(res)
        this.GetFormHeader();
      })
     }else{
      alert("Form header can only include 7 fields. You will need to remove a field from the header before you can add another") 
       this.GetFormHeader()
     }
   }
  }
  toggleIncludeFormHeader(QId:number){
    let check = this.headerFormList.find(x=>x.qid==QId);
   if(check){
      this._formService.UpdateFormHeader(0,QId, this.formId).subscribe(res=>{
        if(res)
        this.GetFormHeader();
      })
   }else{
     if(this.headerFormList.length<6){
      this._formService.UpdateFormHeader(0,QId,this.formId).subscribe(res=>{
        if(res)
        this.GetFormHeader();
      })
     }else{
      alert("Form header can only include 6 fields. You will need to remove a field from the header before you can add another")
       this.GetFormHeader()
     }
   }
  }
//   DeleteQuestion(formId:number, QuestionId:number){
//     this._formService.DeleteSelectedQuestion(formId, QuestionId).subscribe(res=>{
//       if(res>0){
//         this._notification.success('Saved','Delete Question Successfully')
//         this.GetDigitalFormDetails();
//       }else{
//         this._notification.error('Failed','Failed to delete Question')
//       }
//     })
// }


  FormCatSelect(){
    if(this.FormcatId>0){
      this.isFormCategorySelect =true;
      let catName = this.FormCatList.find(x=>x.Id==this.FormcatId).Name;
      if(catName=='Frame Undercarriage Rebuild Centre'){
        this.showFECRTypes=true;
      }else{
        this.showFECRTypes=false;
      }
    }
    if(this.formId==0){
      //create new Form
      this._formService.CreateDigitalForm(this.FormcatId).subscribe(res=>{
        this.formId = res;
        
        this.GetDigitalFormDetails();
      })
    }else{
      console.log("formId", this.formId)
      // UPDATE EXISITING FORM
      this._formService.UpdateDigitalFormCategory(this.formId, this.FormcatId).subscribe(res=>{
        if(res>0){
          this._notification.success('Saved','Update Form Category Successfully')
          this.GetDigitalFormDetails();
        }else{
          this._notification.error('Failed','Failed to update Form Category')
        }
      })
    }
  }

  loadJobsitesForCustomer() {
    if (this.customerId == null)
        return;
    this.JobsiteId = null;
    this.jobsiteList = null;
    var params: JobsiteSelectionFilter = {
        Customers: this.customerId,
      }
    this._formService.GetjobsitesAvailable(params).subscribe(r => {
        if (r) {
          console.log("r", r)
            this.jobsiteList = r;
        }
      });
     // this.LoadAllImplementTypesForCustomers();
  }
  FormCustomersSelect(){
    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.customerId;
    console.log('info', info);
    if(info.selectedList.length !== 0){
      this._formService.UpdateCustomerForForm(info).subscribe(res=>{
      if(res){
        this.loadJobsitesForCustomer();
        //this.loadFamiliesForCustomer();
        //this._notification.success('Saved','Update Form Successfully')
      }else{
        this._notification.error('Failed','Failed to Update Form ')
      }
    });
    }
    else {
     this.JobsiteId = [];
     this.modelId = [];
     this.familyId = []; 
     this.ImpTemplateId = [];
     this.jobsiteList = [];
     this.familyFilteredList = [];
     this.filteredModelList = [];
    }
  }

  loadFamiliesForCustomer(){
    var params: JobsiteSelectionFilter = {
      Customers: this.customerId,
    }
    this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
      if (r) {
        this.familyFilteredList = r;
        console.log("familyFilteredList", this.familyFilteredList)
      }
    });
  }

  FormJobsitesSelect(){
    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.JobsiteId;
    if(info.selectedList.length !== 0){
    this._formService.UpdateJobsiteForForm(info).subscribe(res=>{
      if(res){
        console.log("customerId", this.customerId, "jobsiteId", info.selectedList);
       this.loadFamilyOnJobsite(this.customerId,info.selectedList);
        //this.filteredFamily(this.customerId.join(','),info.selectedList.join(','));
        //this._notification.success('Saved','Update Form Successfully')
      }else{
        this._notification.error('Failed','Failed to Update Form ')
      }
    });
  }
  else {
     this.modelId = [];
     this.familyId = []; 
     this.ImpTemplateId = [];
     this.familyFilteredList = [];
     this.filteredModelList = [];
  }
  }
  
  loadFamilyOnJobsite(customer:number[], jobsite:number[]){
    this._favouriteDialogService.GetFamiliesForSelectedJobsite(customer, jobsite).subscribe(res=>{
      this.familyFilteredList = res;
      console.log("familyFilteredList", this.familyFilteredList)
    });
  }

  loadModelsForFamily(customer:number[], jobsite:number[]){
     this._favouriteDialogService.GetModelsForFamily(customer, jobsite).subscribe(res=>{
      this.filteredModelList = res;
      console.log("modelList", this.modelList)
    });
  }

  filteredFamily(customer:string, jobsite:string){
    this._formService.getFilteredFamilyDetails(customer, jobsite).subscribe(res=>{
      this.filteredFamilyList = res.Data;
      console.log("filteredFamilyList", this.filteredFamilyList)
    });
  }

  UpdateFormName(){
    this._formService.UpdateFormName(this.formId,this.formName,0).subscribe(res=>{
      if(res>0){
        this._notification.success('Saved','Saved Form Name Successfully')
      }else{
        this._notification.error('Failed','Failed to update Form Name')
      }
    })
  }

  toggleEmailOnComplete(){
    this._formService.UpdateEmailOnComplete(this.formId).subscribe(res=>{
      if(res>0)
      this._notification.success('Updated','Update Email on Complete')
    else
      this._notification.error('Failed','Failed to update Email on Complete')
    })
  }
  toggleStartByInspector(){
    debugger
    this._formService.UpdateStartByInspectoor(this.formId).subscribe(res=>{
      if(res>0) {
        this.startbySupervisor = false;
        this._notification.success('Updated','Update Start by Inspector');
      }
    else
      this._notification.error('Failed','Failed to update Start by Inspector');
    });
  }

  toggleStartBySupervisor(){
    debugger
    this._formService.UpdateStartBySupervisor(this.formId).subscribe(res=>{
      if(res>0) {
        this.startbyInspector = false;
        this._notification.success('Updated','Update Start by Supervisor');
      }
    else
      this._notification.error('Failed','Failed to update Start by Supervisor');
    });
  }

  toggleFECRForm(){
    console.log("clecik Fecr", this.FECRForm)
    if(this.FECRForm==true){
      this.showFECRTypes=true;
    }else{
      this.showFECRTypes=false;
    }
    this._formService.UpdateFECRForm(this.formId).subscribe(res=>{
      if(res>0)
      this._notification.success('Updated','Update the Form')
    else
      this._notification.error('Failed','Failed to update the Form')
    })
  }
  
  OpenAddCategory( ) {
    const addCategoeynDialog = this._dialog.open(AddFormcategoryComponent, {
      data: {
        isSection:false,
        isCategoery:true,
        formId:this.formId,
        isEdit: false
      }
    });
    addCategoeynDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }

  OpenAddSection(parentCatId: number, formId:number) {
    const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
      data: {
        parentCatId: parentCatId,
        isSection:true,
        formId:formId,
        isEdit: false
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }

  OpenAddQuestion(sectionId: number, formId:number) {
    const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
      width: '900px',
          height:'800px',
      data: {
        sectionId: sectionId,
        isSection:false,
        isQuestion:true,
        formId:formId,
        QuestionTypes:this.questionTypes,
        customerId:this.customerId,
        modelId:this.modelId,
        isEdit: false
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }
  QuestionDetails:AddQuestionVM;
  OpenEditQuestion( formId:number,QuestionId: number) {

    this._formService.GetQuestionDetails(QuestionId).subscribe(res=>{
      this.QuestionDetails = res;

      const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
        width: '900px',
            height:'800px',
        data: {
          QuestionId: QuestionId,
          isSection:false,
          isQuestion:false,
          isQuestionEdit:true,
          formId:formId,
          QuestionTypes:this.questionTypes,
          QuestionDetails:this.QuestionDetails,
          customerId:this.customerId,
          modelId:this.modelId,
          isEditQ:0,
        }
      });
      addSectionDialog.afterClosed().subscribe(details => {
        if (details ==true) {
          this.GetDigitalFormDetails();
        }
      });
    });
    
  }
  OpenEditCategory(formId:number,catId:number, isParent:boolean,Name:string){
    const addSectionDialog = this._dialog.open(AddFormcategoryComponent, {
      
      data: {
        sectionId: catId,
        isSection:false,
        isQuestion:false,
        isCategoeryEdit:true,
        formId:formId,
        isParent:isParent,
        Name:Name,
        isUpdateCat:0,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==true) {
        this.GetDigitalFormDetails();
      }
    });
  }
  OrderUP_C(order:number, formId:number){
    this._formService.OrderUp_Categories(formId,order).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderDown_C(order:number, formId:number){
    this._formService.OrderDown_Categories(formId,order).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderUP_S(order:number, formId:number,parentId:number){
    this._formService.OrderUp_Section(formId,order,parentId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderDown_S(order:number, formId:number,parentId:number){
    this._formService.OrderDown_Section(formId,order,parentId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  OrderUP_Q(order:number, formId:number,sectionId:number){
    this._formService.OrderUp_Q(formId,order,sectionId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }

  OrderDown_Q(order:number, formId:number,sectionId:number){
    this._formService.OrderDown_Q(formId,order,sectionId).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  toggleForm(questionId:number, Active:boolean){
    //show dialog
 const addSectionDialog = this._dialog.open(ConfirmDialogComponentIdentity, {
  // width: '700px',
  // height:'250px',
  data: {
    open: true,
    isCopied:false,
    isParent:false,
    isDelete:true,
    value:"Question",
  }
});
addSectionDialog.afterClosed().subscribe(details => {
  if (details>0) {
    this._formService.TogglelFormQuestion(questionId,Active,0).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  
});
     
  }

  toggleFormSection(catId:number, Active:boolean){

       //show dialog
 const addSectionDialog = this._dialog.open(ConfirmDialogComponentIdentity, {
  // width: '700px',
  // height:'250px',
  data: {
    open: true,
    isCopied:false,
    isParent:false,
    isDelete:true,
    value:"Section/Category",
  }
});
addSectionDialog.afterClosed().subscribe(details => {
  if (details>0) {
    this._formService.TogglelFormCategory(catId,Active,0).subscribe(res=>{
      this.GetDigitalFormDetails();
    })
  }
  
});
    
  }
   loadModelList() {
    console.log("selectedfamilies", this.familyId)
    this.modelList = null
    if(this.familyId.length>0) {
      this.showModelList=true;
      this._favouriteDialogService.GetModelsForFamily(this.customerId, this.JobsiteId).subscribe(r => {
        if (r) {
          this.filteredModelList = r;
          console.log("filteredModelList", this.filteredModelList)
        }
      });
    //   this._formService.GetModelsAvailable(this.familyId).subscribe(r => {
    //     if (r) {
    //       this.modelList = r;
    //       console.log("modelList", this.modelList)
    //     }
    //   });
    // 
    }else{
      this.showModelList=false;
    }
  }

  SelectModels(){
    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.modelId;
    this._formService.UpdateFormModels(info).subscribe(res=>{
      if(res){
        //this._notification.success('Saved','Update Form Successfully')
        this.LoadImplementTemplateList();
      }else{
        this._notification.error('Failed','Failed to Update Form ')
      }
    })
  }

  ReloadPage(){
    this._document.defaultView.location.reload();
  }


  LoadImplementTemplateList(){
    let params =  new ImplementLoadVM();
     params.customer=this.customerId==undefined?[]:this.customerId;
     params.models=this.modelId==undefined?[]:this.modelId;
     console.log("list", params)
      this._formService.LoadImplmentTemplates(params).subscribe(res=>{
        this.ImplementTemplateList = res;
      });
  }

  SelectImplement(){
   // let array_ = [];
     //array_.push(this.ImpTemplateId);
    var info = new UpdateCustomerVM();
    info.formId=this.formId;
    info.selectedList=this.ImpTemplateId;
    this._formService.UpdateFormImplementTemplate(info).subscribe(res=>{
      if(res){
        this._notification.success('Saved','Update Form Successfully')
      }else{
        this._notification.error('Failed','Failed to Update Implement Link. ')
      }
    })
  }

  // OpenModifyImplement(){
  //   this._appService.getUndercarriageUrl().subscribe(result => {
  //     if (result != null && result != '')
  //         window.open(result+'setup/existing-implement-new/' + this.ImpTemplateId, '_blank');
  //  //this._sanitizer.bypassSecurityTrustUrl(result+'setup/existing-implement-new/' + this.ImpTemplateId); //result+'digitalForm/search';
  //   });
  // }

  
}
